import { getToday, priceFormat } from "components/utils/comm";
import { ForwardedRef, forwardRef } from "react";
import { IRmPdStas } from "interface/rm/crr";
import { useTranslation } from "react-i18next";
import { useCalendarCardInfContext } from "../context";
import StatusModal from "../modal/status";
import PriceModal from "../modal/price";
import RoomCountModal from "../modal/rmCt";
import ProductHistoryModal from "../modal/productHistory";
import "./calendar.scss";

type IProps = {
  week: any;
  rmPds: IRmPdStas | undefined;
};

const Card = ({ week, rmPds }: IProps, ref: ForwardedRef<HTMLLIElement>) => {
  const { t } = useTranslation();

  const { btnTyp, setCardInf, setBtnTyp } = useCalendarCardInfContext();

  const today = getToday();
  /**
   * 오늘날짜 주일로 스크롤 자동 이동하기
   * 상태변경
   * 상품수량 변경
   * 상품가격 변경
   * 상품 이력 확인
   */
  return (
    <>
      <li className="day-card" ref={ref}>
        <span is-last={week.isLast + ""} is-sunday={(week.day === 0) + ""}>
          {week.dateSt}
        </span>
        {!rmPds?.lodChlList && (
          <div className="h-[80%] flex justify-center items-center text-xs text-red-500">
            {t("txt_no_list")}
          </div>
        )}
        {rmPds?.lodChlList &&
          rmPds?.lodChlList.map((rmPd, index) => {
            return (
              <div key={index}>
                <h5 className={"bg-navy-300 text-white mb-1"}>
                  {rmPd.lodChlNm}
                </h5>
                {rmPd.rmPdList.map((item, index) => {
                  return (
                    <ul
                      key={index}
                      className="px-2"
                      data-last={week.fullDate < today}
                    >
                      <li className="flex gap-2 mb-1">
                        <button
                          className={
                            "w-[40px] h-[16px] text-white cursor-pointer " +
                            " " +
                            (item.sellStaCd === "S01"
                              ? "bg-green-500"
                              : "bg-red-500")
                          }
                          onClick={() => {
                            setCardInf({
                              ...item,
                              sellDt: week.dateSt,
                            });
                            setBtnTyp("status");
                          }}
                        >
                          {item.sellStaNm}
                        </button>
                        <p className="rm-nm">{item.rmNm}</p>
                      </li>
                      <li
                        className="px-2 underline decoration-1 cursor-pointer"
                        onClick={() => {
                          setCardInf({
                            ...item,
                            sellDt: week.dateSt,
                          });
                          setBtnTyp("price");
                        }}
                      >
                        {t("txt_sell_price")}:{" "}
                        <strong className="text-red-300">
                          {priceFormat({ price: item.sellPri })}
                        </strong>
                      </li>
                      <li
                        className="px-2 underline decoration-1 cursor-pointer"
                        onClick={() => {
                          setCardInf({
                            ...item,
                            sellDt: week.dateSt,
                            lodChlCd: rmPd.lodChlCd,
                          });
                          setBtnTyp("rmCt");
                        }}
                      >
                        {t("txt_create")} : <strong>{item.sellCt}</strong>
                      </li>
                      <li className="px-2 ">
                        {t("txt_sell")} : <strong>{item.sellDoneCt}</strong>
                      </li>
                      <li className="px-2 ">
                        <button
                          className="underline decoration-1 cursor-pointer pointer-events-auto"
                          onClick={() => {
                            setCardInf(item);
                            setBtnTyp("history");
                          }}
                        >
                          {t("txt_hst_rmpd")}
                        </button>
                      </li>
                    </ul>
                  );
                })}
              </div>
            );
          })}
      </li>

      {/* 상태변경 모달창 */}
      {btnTyp === "status" && (
        <StatusModal
          isOpen={btnTyp === "status"}
          onClose={() => setBtnTyp("")}
        />
      )}

      {/* 가격변경 모달창 */}
      {btnTyp === "price" && (
        <PriceModal isOpen={btnTyp === "price"} onClose={() => setBtnTyp("")} />
      )}
      {/* 상품수량변경 모달창 */}
      {btnTyp === "rmCt" && (
        <RoomCountModal
          isOpen={btnTyp === "rmCt"}
          onClose={() => setBtnTyp("")}
        />
      )}

      {/* 상세이력조회 모달창 */}
      {btnTyp === "history" && (
        <ProductHistoryModal
          isOpen={btnTyp === "history"}
          onClose={() => setBtnTyp("")}
        />
      )}
    </>
  );
};

export default forwardRef<HTMLLIElement, IProps>(Card);
